/**
 * @generated SignedSource<<6587c7bc49882f99054b6fbcfcc48665>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ORConsoleHeaderQuery$variables = {
  id: string;
};
export type ORConsoleHeaderQuery$data = {
  readonly surgery: {
    readonly id: string;
    readonly location: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type ORConsoleHeaderQuery = {
  response: ORConsoleHeaderQuery$data;
  variables: ORConsoleHeaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Surgery",
    "kind": "LinkedField",
    "name": "surgery",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Location",
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ORConsoleHeaderQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ORConsoleHeaderQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "bf0d8847bd2ef2b644decb049da63b53",
    "id": null,
    "metadata": {},
    "name": "ORConsoleHeaderQuery",
    "operationKind": "query",
    "text": "query ORConsoleHeaderQuery(\n  $id: ID!\n) {\n  surgery(id: $id) {\n    id\n    name\n    location {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d6c73de7c47bf69e61eac984eab647a";

export default node;
